<template>
  <panel with-header>
    <header slot="header" class="flex items-center border-b pb-4">
      <div class="w-12 h-12 flex-no-shrink bg-tertiary rounded-lg mr-6 text-white">
        <!-- <i class="fas fa-users fa-2x"></i> -->
        <icon name="staff" class="p-1" />
      </div>
      <h1 class="text-black text-2xl font-semibold">Users</h1>
    </header>

    <user-form
      v-if="selectedUser"
      :user="selectedUser"
      @saved="userAdded"
      @cancel="selectedUser = null"
    />

    <div v-else>
      <user-list
        :users="users"
        @select="selectedUser = $event"
        @delete="deleteUser"
      />

      <div class="flex justify-center mt-6">
        <button
          class="text-sm w-48 px-4 py-1 flex items-center justify-center text-grey-darkest rounded-lg shadow hover:shadow-none border border-blue bg-white leading-none"
          @click="newUser"
        >
          <span class="mr-2 text-xl">&#43;</span>
          New User
        </button>
      </div>
    </div>

  </panel>
</template>

<script>
import api from '@/http'
import { mapState, mapActions } from 'vuex'
import UserList from '@/components/UserAdmin/UserList'
import UserForm from '@/components/UserAdmin/UserForm'

export default {
  components: { UserList, UserForm },

  data () {
    return {
      selectedUser: null,
      users: []
    }
  },

  computed: {
    ...mapState(['selectedOffice'])
  },

  methods: {
    ...mapActions(['displayToastNotification']),

    newUser () {
      this.selectedUser = {
        'first_name': null,
        'surname': null,
        'email': null,
        'password': null,
        'password_confirmation': null,
        'office_id': this.selectedOffice.id,
        'referral_system': false,
        'knowledge_hub': false
      }
    },

    userAdded () {
      this.fetch()
      this.selectedUser = null
    },

    deleteUser (user) {
      api
        .delete(`/users/${user.id}`)
        .then(() => {
          this.fetch()
        })
        .catch(({ response }) => {
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-bell',
            title: 'Unable to delete user',
            info: response.data.message
          })
        })
    },

    fetch () {
      if (!this.selectedOffice.id) {
        return
      }

      api
        .get('/users', {
          params: { office_id: this.selectedOffice.id }
        })
        .then(response => {
          this.users = response.data
        })
        .catch()
    }
  },

  created () {
    this.fetch()
  },

  watch: {
    selectedOffice () {
      this.fetch()
    }
  }
}
</script>
